export { LocaleProvider, useLocale } from './locale-provider';
export { locales, defaultLocale, type Locale } from './config';

